import { Products } from './productsTypes';
import { Action } from '../../generalTypes';

export const SET_PRODUCTS: string = 'SET_PRODUCTS';

export const actionSetProducts = (products: Products): Action<Products> => ({
  type: SET_PRODUCTS,
  payload: products,
});
